import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { InputWidthValues } from '../../../ui/gzInput/index';

export const templateEditIntegration = document.createElement('template');

templateEditIntegration.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class="form-wrapper compact" id="edit-integration">
    <div>
      <p id="company_name"></p>
      <gz-form-field id="integration_name" required stacked >
          <gz-input gz-form-input type="text" inputWidth='${InputWidthValues.XLARGE}'></gz-input>
          <gz-input-error></gz-input-error>
      </gz-form-field>
      <gz-button type="link" color="primary"  buttonfontsize="medium"  id="confirmed_requirements_button" class="hidden"/>
    </div>
    <div id="sensors_area" class="mb-2">
    </div>
    <gz-button id="test_connectivity" disabled lowercase/>
    </div>
</div>`;
